import * as React from 'react';
import * as I18nAPI from '../api/i18n';
import { DebugMode } from '../contexts';
export function i18nFixtureName({ id, sport, fixtureName }, debug) {
    const translation = I18nAPI.translate('outrights', `${sport}-${id}`);
    if (debug) {
        return id + (translation ? '*' : '');
    }
    return translation || fixtureName;
}
const FixtureName = props => {
    const debugEnabled = React.useContext(DebugMode);
    return React.createElement(React.Fragment, null, i18nFixtureName(props, debugEnabled));
};
export default FixtureName;
//# sourceMappingURL=FixtureName.js.map